import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './wpbbsa-calculator-form.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';
var WpbbsaCalculatorForm = /** @class */ (function (_super) {
    tslib_1.__extends(WpbbsaCalculatorForm, _super);
    function WpbbsaCalculatorForm(element) {
        var _this = _super.call(this, element) || this;
        _this.timeout = null;
        _this.formValid = true;
        return _this;
    }
    WpbbsaCalculatorForm.prototype.init = function () {
        this.inputs = Array.from(this.element.querySelectorAll('input, select'));
        this.modifiers = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-modifier'));
        this.modifierToggles = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-modifier-toggle'));
        this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-radio-group'));
        this.addonToggles = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-addon-toggle'));
        this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-calculate'));
        this.calculatorReset = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-reset'));
        this.calculator = this.element.querySelector('form');
        this.copyFields = Array.from(this.element.querySelectorAll('.js-copy-field'));
        this.modalLinks = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-modal'));
        this.termChecker = Array.from(this.element.querySelectorAll('select[name=term]'));
        TooltipsService.initTooltips();
    };
    WpbbsaCalculatorForm.prototype.bindEvents = function () {
        var _this = this;
        this.modifiersRadiosToggle.map(function (modifiersRadiosToggleItem) { return modifiersRadiosToggleItem.addEventListener('click', function (event) {
            var targetField = event.target;
            var visibleGroups = Array.from(_this.element.querySelectorAll('div.' + targetField.getAttribute('data-value')));
            var radioContainers = Array.from(_this.element.querySelectorAll('.js-wpbbsa-calculator-radio-group-containers'));
            radioContainers.map(function (radioContainerItem) {
                radioContainerItem.classList.add('wpbbsa-calculator-form__hidden');
                var inputs = Array.from(radioContainerItem.querySelectorAll('input'));
                inputs.map(function (item) {
                    var getDefaultValue = item.value;
                    if (!getDefaultValue === undefined || getDefaultValue === '') {
                        item.value = '';
                    }
                    else {
                        item.value = getDefaultValue;
                    }
                });
            });
            visibleGroups.map(function (item) {
                item.classList.remove('wpbbsa-calculator-form__hidden');
            });
        }); });
        this.calculatorReset.map(function (item) { return item.addEventListener('click', function (event) {
            _this.resetInputs(event);
            $('html,body').animate({
                scrollTop: $(_this.element)
                    .closest(".wpbbsa-calculators")
                    .offset().top - 80
            }, 'slow');
        }); });
        this.modifierToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleModifiers(event);
        }); });
        this.addonToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleAddons(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('input', function (event) {
            _this.copyField(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('change', function (event) {
            _this.copyField(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModal(event);
        }); });
        // INPUTS
        this.inputs.map(function (item) { return item.addEventListener('focusin', function (event) {
            _this.onFocusInput(event);
        }); });
        this.inputs.map(function (item) { return item.addEventListener('focusout', function (event) {
            _this.outFocusInput(event);
        }); });
        this.inputs.map(function (item) { return item.addEventListener('keyup', function (event) {
            _this.keyInput(event);
        }); });
        if (this.termChecker) {
            this.termChecker.map(function (item) { return item.addEventListener('change', function (event) {
                _this.checkBaloonPayments(event);
            }); });
        }
        // DATE PICKER
        $(document).ready(function () {
            if ($('input.js-date-picker')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    daysOfWeekDisabled: [0, 6],
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker', datePickerConfig);
            }
            if ($('input.js-date-picker-full')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker-full', datePickerConfig);
            }
            function instantiateDate(pSelector, pConfig) {
                $('input' + pSelector).datepicker(pConfig).on('changeDate', function (event) {
                    var _event;
                    if (typeof window.event === 'function') {
                        _event = new Event('change');
                        this.dispatchEvent(_event);
                    }
                    else {
                        _event = document.createEvent('HTMLEvents');
                        _event.initEvent('change', false, false);
                        this.dispatchEvent(_event);
                    }
                });
            }
        });
    };
    WpbbsaCalculatorForm.prototype.openModal = function (event) {
        var modalId = event.currentTarget.parentNode.getAttribute('data-modal');
        this.event.emit('openModal', {
            id: modalId
        });
    };
    WpbbsaCalculatorForm.prototype.copyField = function (event) {
        var fieldParentContainer = this.findFieldCopy(event.target.parentNode);
        var copyValue = Number.parseFloat(event.target.value);
        var _tmpValue = String(event.target.value).split('.');
        if (_tmpValue.length > 1) {
            if (_tmpValue[1].length > 2) {
                copyValue = Number.parseFloat(event.target.value).toFixed(2);
            }
        }
        var fieldName = fieldParentContainer.getAttribute('data-target');
        var fields = fieldParentContainer.querySelectorAll(".js-" + fieldName);
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].classList.contains('js-not-zero')) {
                if (copyValue === 0) {
                    copyValue = 1;
                }
            }
            fields[i].value = copyValue;
        }
        // Form form start (if not started yet) when slider is being interacted with
        this.analyticsService.dtmTriggerFormStart(fields[0]);
    };
    WpbbsaCalculatorForm.prototype.findFieldCopy = function (parent) {
        while (!parent.classList.contains('js-copy-fields')) {
            parent = parent.parentElement;
        }
        return parent;
    };
    WpbbsaCalculatorForm.prototype.toggleModifiers = function (event) {
        event.preventDefault();
        var targetModifierId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetModifier = this.element.querySelector("#" + targetModifierId);
        if (targetModifier.classList.contains('wpbbsa-calculator-form__modifiers--open')) {
            targetModifier.classList.remove('wpbbsa-calculator-form__modifiers--open');
            event.currentTarget.classList.add('wpbbsa-calculator-form__link--open');
        }
        else {
            targetModifier.classList.add('wpbbsa-calculator-form__modifiers--open');
            event.currentTarget.classList.remove('wpbbsa-calculator-form__link--open');
        }
    };
    WpbbsaCalculatorForm.prototype.toggleAddons = function (event) {
        event.preventDefault();
        if (event.currentTarget.classList.contains('link--disabled')) {
            return;
        }
        var targetAddonId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetAddon = this.element.querySelector('#' + targetAddonId);
        var targetInput = targetAddon.querySelector('input');
        var _tmpText = event.currentTarget.querySelector('.link__text');
        var _coAppText = this.element.querySelector('.co_app_text');
        if (targetAddon.classList.contains('wpbbsa-calculator-form__addon--open')) {
            if (targetInput) {
                targetInput.value = '0';
                targetInput.placeholder = '0';
            }
            targetAddon.classList.remove('wpbbsa-calculator-form__addon--open');
            _tmpText.innerText = '+ Add co-applicant\'s income';
            if (_coAppText) {
                _coAppText.innerText = '';
            }
        }
        else {
            if (targetInput) {
                targetInput.value = '0';
                targetInput.placeholder = '0';
            }
            targetAddon.classList.add('wpbbsa-calculator-form__addon--open');
            _tmpText.innerText = '- Remove co-applicant\'s income';
            if (_coAppText) {
                _coAppText.innerText = '(including co-applicant)';
            }
        }
    };
    WpbbsaCalculatorForm.prototype.resetInputs = function (event) {
        event.preventDefault();
        var errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
        errorLabels.map(function (item) {
            var parent = item;
            $(parent).removeClass('wpbbsa-calculator-form__error');
            $(parent).find('div.wpbbsa-calculator-form__error-label').remove();
        });
        this.calculator.reset();
        this.formValid = true;
        this.inputs.map(function (item) {
            if (item.getAttribute('type') !== 'radio') {
                item.setAttribute('data-value', 0);
                item.setAttribute('placeholder', 0);
            }
            if (item.classList.contains('form__datepicker')) {
                item.setAttribute('data-value', '');
                item.setAttribute('placeholder', '');
            }
        });
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmRestartForm();
    };
    WpbbsaCalculatorForm.prototype.onFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        var _value = parseFloat(field.value);
        var min = parseFloat(field.getAttribute('min'));
        var max = parseFloat(field.getAttribute('max'));
        if (min && max) {
            if ((_value < min) || (_value > max)) {
                field.value = '';
            }
        }
        else {
            if (_value === 0) {
                field.value = '';
            }
        }
    };
    WpbbsaCalculatorForm.prototype.outFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        if (!field.classList.contains('js-copy-field')) {
            var value = field.getAttribute('data-value');
            // field.value = value;
            if (field.value === '') {
                field.value = value;
            }
        }
    };
    WpbbsaCalculatorForm.prototype.keyInput = function (event) {
        event.preventDefault();
        this.formValid = true;
        var field = event.target;
        var value = field.value;
        if (!field.classList.contains('js-copy-field')) {
            field.setAttribute('data-value', value);
            field.setAttribute('placeholder', value);
        }
        this.formValid = this.validationService.validateWpbbsaCalculatorEvent(event, this.calculatorSubmit);
    };
    WpbbsaCalculatorForm.prototype.checkBaloonPayments = function (event) {
        var value = event.currentTarget.value;
        var balloonInput = Array.from(this.element.querySelectorAll('.js-balloon'));
        if (balloonInput.length > 0) {
            if (value === '84') {
                balloonInput.forEach(function (element) {
                    element.value = '0';
                    element.placeholder = '0';
                    element.max = '0';
                    element.min = '0';
                    element.setAttribute('data-value', '0');
                });
            }
            else {
                balloonInput.forEach(function (element) {
                    element.value = '1';
                    element.placeholder = '1';
                    element.max = '40';
                    element.min = '1';
                    element.setAttribute('data-value', '1');
                });
            }
        }
    };
    return WpbbsaCalculatorForm;
}(Base));
export { WpbbsaCalculatorForm };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-calculator-form/wpbbsa-calculator-form.component.ts
// module id = 1001
// module chunks = 0